var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view',{attrs:{"name":"navbar"}}),_vm._v(" "),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('v-footer',[_c('v-layout',{attrs:{"justify-end":""}},[_c('span',{staticClass:"caption font-weight-light"},[_vm._v("© Grupo Puntacana, Dominican Republic.")])])],1),_vm._v(" "),_c('router-view',{attrs:{"name":"busy"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"notification"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layouts/DashboardLayout.vue?vue&type=template&id=9ca72a40
// module id = null
// module chunks = 